module.exports = __webpack_public_path__ + "static/media/lessons_icon.8687ad8e.png";